// extracted by css-extract-rspack-plugin
export default {"root":"bolz5","selected":"QtP4q","expandToggle":"RUuwS","expandIcon":"O_4Bd","expanded":"PAcKy","name":"CUxr6"};